import React from "react";
import * as S from "./SpinnerLoading.style";
const SpinnerLoading = ({ center, alone }) => {
  return (
    <S.Container center={center} alone={alone}>
      <S.StyledSpinner />
    </S.Container>
  );
};

export default SpinnerLoading;
